module.exports = __webpack_public_path__ + "img/horizontal_4_6_1.2630d057.png";